import emitter from "../utils/emitter";

export default function useModalActions() {
  const closeModal = (modalType) => {
    emitter.emit(modalType, { isOpen: false, payload: {} });
  };
  const openModal = (modalType, payload) => {
    emitter.emit(modalType, { isOpen: true, payload });
  };
  return {
    closeModal,
    openModal,
  };
}
